module.exports = __webpack_public_path__ + "static/media/step3.b721644a.svg";